import React from 'react';

import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const Bitrix = () => {
    return (
        <div className="bitix-pochtabank">
            <FullWrapper>
                <div className="bitix-pochtabank__Title">
                    Api Based на&nbsp;базе Bitrix Framework
                </div>
                <div className="bitix-pochtabank__Inner">
                    <div className="bitix-pochtabank__Left">
                        <div>
                            В&nbsp;проекте мы&nbsp;использовали современный фронтенд на&nbsp;базе
                            React, а&nbsp;от&nbsp;бэкендеров требовалось на&nbsp;базе Bitrix
                            Framework создать api и&nbsp;отдать его команде фронтенда.
                        </div>
                        <div>
                            Для обмена контрактом мы&nbsp;использовали стандарт OpenApi. Специально
                            для Битрикс написали код, из&nbsp;которого генерируется конфиг
                            (и&nbsp;выложили код в&nbsp;open source). Пакет также поставляет
                            SwaggerUI для упрощенного тестирования. Как мы&nbsp;строим API Based
                            подход на&nbsp;Bitrix Framework, рассказываем на&nbsp;
                            <a
                                href="https://www.youtube.com/watch?v=XmzQtKwieDM&t=1s"
                                target="_blank"
                                rel="noreferrer"
                            >
                                PHP конференции.
                            </a>
                        </div>
                        <div>
                            Для миграций использовали phinx, а&nbsp;консольные команды писали
                            на&nbsp;базе symfony/console. В&nbsp;качестве баз данных
                            мы&nbsp;использовали репликацию на&nbsp;базе Mysql как сервис Яндекс.
                            Облака. Качественная оркестрация этого сервиса позволяет при сбое
                            в&nbsp;master почти моментально переключить трафик на&nbsp;slave,
                            который становится мастером в&nbsp;автоматическом режиме.
                        </div>
                    </div>
                    <div className="bitix-pochtabank__Right">
                        <div className="bitix-pochtabank__Description">
                            <div className="bitix-pochtabank__Top">
                                Разработанный нами пакет Bitrix Open Api можно скачать на&nbsp;
                                <a
                                    href="https://github.com/webpractik/bitrixoa"
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    github
                                </a>{' '}
                                или <a>composer</a>
                            </div>
                            <div className="bitix-pochtabank__Bottom">
                                <img
                                    src="/images/pic/new-pochtabank/github.jpg"
                                    alt="github"
                                    className="bitix-pochtabank__Icon"
                                />
                                <div>webpractik/bitrixoa</div>
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Bitrix;
